import axios from 'axios'
export default function axiosGet(url, handleReply) {
    axios({	
        method: 'get',
        url: url, 
    })
    .then(
        response => {
            console.log('OK: axiosGet response.data:', response.data?response.data:'no data');
            handleReply(response.data);
    })  
    .catch(e => {
            console.log('(Function: axiosGet) ERROR:', e?e:'No event e');
            handleReply(null)
    })
}